import { useQuery } from 'react-query'
import { useRouter } from 'next/router'

import { fetchCart } from './fetchers'
import { CartHookBag } from './types'

export function useCart(promoCode?: string): CartHookBag {
  const { query } = useRouter()

  return useQuery(
    [
      'cart',
      {
        promoCode,
        partner:
          query.ref?.toString().toLowerCase() !== 'inspectcheck'
            ? query.ref
            : '',
        affiliate: query.affiliate ?? ''
      }
    ],
    fetchCart(),
    {
      retry: false
    }
  )
}
